module.exports = __webpack_public_path__ + "img/logo-famille-boutrais-gris-footer.4fdd2f4d.webp";